import { setCookie, getCookie, eraseCookie } from 'utils/cookies';

class CookieBar {
  constructor(element, options = {}) {
    this._element = element;
    this._elements = {
      html: document.documentElement,
      body: document.body,
    };
    this._regionToggle = document.querySelector('#user_menu .region-toggle');
    this._region = document.querySelector('#region_selector');
    this._notification = document.querySelector('#user_menu .user-menu__notification');
    this._checkboxes = [...element.querySelectorAll("[type='checkbox']")];
    this._submit = element.querySelector('button.button--primary');
    this._cancel = element.querySelector('button.button--diapositive');
    this._options = { ...CookieBar.options, ...options };

    if (this._region === null) {
      return;
    }
    this._init();
    this._setEventListeners();
  }

  _state = {
    active: false,
    scrollTop: 0,
  };

  static options = {
    cookieName: 'cookie_necessary',
    cookies: {
      mandatory: ['cookie_necessary', 'cookie_statistics'],
      optional: ['cookie_marketing'],
    },
    timeout: 2500,
  };

  _init() {
    this._element.setAttribute('aria-hidden', 'true');
    // Just a safety measure, the whole cookie bar should not be rendered if cookies are already accepted
    if (getCookie(this._options.cookieName) !== null) {
      this._state.active = false;
      this._region.setAttribute('data-newsession', false);

      // console.warn(
      //   '@backend: please omit the cookie bar when cookies are already accepted.'
      // )
    } else {
      this._region.setAttribute('data-newsession', true);
      this._state.active = true;
    }

    this._element.setAttribute('aria-hidden', !this._state.active);
    this._handleModal();
  }

  _setEventListeners() {
    this._submit.addEventListener('click', () => {
      this._options.cookies.mandatory.forEach((cookie) => {
        setCookie(cookie, true, 90);
      });
      this._options.cookies.optional.forEach((cookie) => {
        setCookie(cookie, true, 90);
      });
      this._state.active = false;
      this._setVisibility();
    });

    this._cancel.addEventListener('click', () => {
      this._options.cookies.mandatory.forEach((cookie) => {
        setCookie(cookie, true);
      });
      this._options.cookies.optional.forEach((cookie) => {
        eraseCookie(cookie);
      });
      this._state.active = false;
      this._setVisibility();
    });
  }

  _setVisibility() {
    this._element.setAttribute('aria-hidden', !this._state.active);
    this._handleModal();
    this._showNotification();
  }

  _showNotification() {
    if (this._state.active) {
      return;
    }
    this._notification.setAttribute('data-active', true);
    const t = setTimeout(() => {
      this._notification.setAttribute('data-active', false);
      clearTimeout(t);
    }, this._options.timeout);
  }

  _handleModal() {
    this._elements.html.setAttribute('data-overflow', !this._state.active);
    this._elements.body.setAttribute('data-modal', this._state.active);
    /* eslint-disable-next-line */
    this._state.active ? this._disableScroll() : this._enableScroll();
  }

  _enableScroll() {
    this._elements.body.scrollTop = this._elements.html.scrollTop = this._state.scrollTop;
    this._state.scrollTop = 0;
    this._element.scrollTop = 0;
  }

  _disableScroll() {
    this._state.scrollTop = this._elements.body.scrollTop || this._elements.html.scrollTop;
  }
}

export default CookieBar;
